import { render, staticRenderFns } from "./FailModal.vue?vue&type=template&id=32132492&scoped=true&"
import script from "./FailModal.vue?vue&type=script&lang=js&"
export * from "./FailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32132492",
  null
  
)

export default component.exports